import axios from "axios";
import { CONFIG } from "../config";

/**
 * Centralized Axios instance for all API calls
 * This instance is configured with the base URL and default headers
 * and will have interceptors attached for authentication
 */
export const apiClient = axios.create({
  baseURL: CONFIG.API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
